import loadable from '@loadable/component'

export const HorizontalList = loadable(() => import('./HorizontalList'))
export const HorizontalListItem = loadable(() => import('./HorizontalListItem'))
export const LinkList = loadable(() => import('./LinkList'))
export const LinkListItem = loadable(() => import('./LinkListItem'))
export const List = loadable(() => import('./List'))
export const ListItem = loadable(() => import('./ListItem'))

export type { HorizontalListProps } from './HorizontalList'
export type { HorizontalListItemProps } from './HorizontalListItem'
export type { LinkListProps } from './LinkList'
export type { LinkListItemProps, ListItemRenderLinkProps } from './LinkListItem'
export type { ListProps } from './List'
export type { ListItemProps } from './ListItem'
